import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { adminxApi } from './api/actions/adminxApi';
import authReducer from './api/reducers/authReducer';

const staticReducers = {
  [adminxApi.reducerPath]: adminxApi.reducer,
  auth: authReducer,
};

function createReducer(asyncReducers) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
}

const store = configureStore({
  reducer: createReducer({}),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(adminxApi.middleware),
});

// Dynamic reducers are injected by lazily loaded signup components.
store.asyncReducers = {};

// Rebuild the root reducer only when a previously unseen reducer is injected.
store.injectReducer = (objReducer) => {
  let hasNewReducer = false;
  for (let key in objReducer) {
    if (!store.asyncReducers[key]) {
      hasNewReducer = true;
      store.asyncReducers[key] = objReducer[key];
    }
  }
  if (hasNewReducer) {
    store.replaceReducer(createReducer(store.asyncReducers));
  }
};

setupListeners(store.dispatch);
export default store;
